export default __webpack_public_path__ + "static/media/lighttpd.f598dbfb.svg";